<main class="dialog-body">
  <div class="dialog-header">
    <div class="dialog-header-text">FAQ</div>
    <div class="cross-icon" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="accordion-container">
      <!-- Skeleton Loader -->
      <div *ngIf="isLoading" class="skeleton-container">
        <div *ngFor="let item of [1, 2, 3, 4]" class="skeleton-section"></div>
      </div>

      <!-- Actual Content -->
      <div *ngIf="!isLoading && accordionData.length > 0">
        <div
          *ngFor="let item of accordionData"
          class="accordion-section"
          (click)="toggle(item)"
        >
          <div class="accordion-header" [class.expanded]="item.expanded">
            <span>{{ item.title }}</span>
            <span class="icon">
              <ng-container *ngIf="item.expanded; else collapsed">
                <svg
                  width="15"
                  height="7.5"
                  viewBox="0 0 10 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 4.5L5 0.5L0.5 4.5"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </ng-container>
              <ng-template #collapsed>
                <svg
                  width="15"
                  height="7.5"
                  viewBox="0 0 10 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5 0.5L5 4.5L9.5 0.5"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </ng-template>
            </span>
          </div>

          <div class="accordion-content" *ngIf="item.expanded">
            <div
              *ngIf="item.children && item.children.length > 0; else noContent"
            >
              <div *ngFor="let child of item.children" class="nested-item">
                <div
                  class="nested-header"
                  (click)="toggle(child); $event.stopPropagation()"
                  [class.expanded]="child.expanded"
                >
                  <span>{{ child.title }}</span>

                  <ng-container *ngIf="child.expanded; else collapsed">
                    <svg
                      width="9"
                      height="2"
                      viewBox="0 0 9 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.16358 0H8.11419C8.30983 0 8.49746 0.077717 8.63579 0.216054C8.77413 0.354391 8.85185 0.542016 8.85185 0.737654C8.85185 0.933292 8.77413 1.12092 8.63579 1.25925C8.49746 1.39759 8.30983 1.47531 8.11419 1.47531H5.16358H0.737654C0.542016 1.47531 0.354391 1.39759 0.216054 1.25925C0.0777171 1.12092 0 0.933292 0 0.737654C0 0.542016 0.0777171 0.354391 0.216054 0.216054C0.354391 0.077717 0.542016 0 0.737654 0H5.16358Z"
                        fill="white"
                      />
                    </svg>
                  </ng-container>

                  <ng-template #collapsed>
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.11419 3.68827H5.16358V0.737654C5.16358 0.542016 5.08586 0.354391 4.94752 0.216054C4.80919 0.077717 4.62156 0 4.42592 0C4.23029 0 4.04266 0.077717 3.90432 0.216054C3.76599 0.354391 3.68827 0.542016 3.68827 0.737654V3.68827H0.737654C0.542016 3.68827 0.354391 3.76599 0.216054 3.90432C0.077717 4.04266 0 4.23029 0 4.42592C0 4.62156 0.077717 4.80919 0.216054 4.94752C0.354391 5.08586 0.542016 5.16358 0.737654 5.16358H3.68827V8.11419C3.68827 8.30983 3.76599 8.49746 3.90432 8.63579C4.04266 8.77413 4.23029 8.85185 4.42592 8.85185C4.62156 8.85185 4.80919 8.77413 4.94752 8.63579C5.08586 8.49746 5.16358 8.30983 5.16358 8.11419V5.16358H8.11419C8.30983 5.16358 8.49746 5.08586 8.63579 4.94752C8.77413 4.80919 8.85185 4.62156 8.85185 4.42592C8.85185 4.23029 8.77413 4.04266 8.63579 3.90432C8.49746 3.76599 8.30983 3.68827 8.11419 3.68827Z"
                        fill="white"
                      />
                    </svg>
                  </ng-template>
                </div>

                <div
                  class="nested-content"
                  *ngIf="child.expanded"
                  (click)="$event.stopPropagation()"
                >
                  {{ child.content }}

                  <p class="fallback-text" *ngIf="!child.content">
                    No content added
                  </p>
                </div>
              </div>
            </div>

            <ng-template #noContent>
              <div class="nested-no-item">No content added</div>
            </ng-template>
          </div>
        </div>
      </div>

      <div *ngIf="!isLoading && accordionData.length === 0" class="no-data">
        No data available
      </div>
    </div>
  </mat-dialog-content>
</main>
